import { Component, input, viewChild } from '@angular/core';
import { IColumn } from '@app/shared/interfaces/column.interface';
import { IFiltredDashboardResponse } from '@app/shared/interfaces/dashboard.interface';
import { TableComponent } from '@app/shared/components/table-component/table.component';
import { ExcelButtonComponent } from '@app/shared/components/excel-button/excel-button.component';
import { CardComponent } from '@app/shared/components/card/card.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-airline-statistics',
    imports: [CommonModule, TableComponent, ExcelButtonComponent, CardComponent],
    templateUrl: './airline-statistics.component.html',
    styleUrl: './airline-statistics.component.scss'
})
export class AirlineStatisticsComponent {
    airlineCodeTemplate = viewChild('airlineCodeTemplate');
    paxProgressTemplate = viewChild('paxProgressTemplate');

    loading = input<boolean>(false);
    airlineStatisticsData = input<IFiltredDashboardResponse['airlineStatistic']['results']>();

    cols: IColumn[] = [];

    ngOnInit() {
        this.cols = [
            { key: 'airlineCode', label: 'Airline', template: this.airlineCodeTemplate(), sortable: true },
            { key: 'provider', label: 'Provider', sortable: true },
            { key: 'supplier', label: 'Supplier', sortable: true },
            { key: 'pax', label: 'Pax', template: this.paxProgressTemplate(), sortable: true },
            { key: 'lastYearPax', label: 'Last Year', sortable: true }
        ];
    }

    exportData(): any[] {
        return (
            this.airlineStatisticsData()?.map((item) => ({
                airlineCode: item.airlineCode ?? '',
                provider: item.provider ?? '',
                supplier: item.supplier ?? '',
                pax: item.pax ?? '',
                lastYearPax: item.lastYearPax ?? ''
            })) ?? []
        );
    }
}
